import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getRenewalInfo } from './billing-data.reducer';
import { RenewalInfo } from './models/renewal-info.model';

@Injectable()
export class BillingDataStore {
  renewalInfo$: Observable<RenewalInfo> = this._store.select(getRenewalInfo);

  constructor(private _store: Store<any>) {}
}
